import { Link } from 'react-router-dom';



const AdvantagesBox = (): JSX.Element => {

	return (
		<div className='advantages-box'>

			<h2>Milý zákazníku, děkujeme za&nbsp;zájem o&nbsp;náš produkt!</h2>
			
			<p>GASTRO límec pro&nbsp;jícnovou sondu jsme vyvíjeli na&nbsp;základě požadavků&nbsp;veterinárních lékařů, jsme tedy přesvědčeni, že&nbsp;se&nbsp;stane velkým&nbsp;pomocníkem při&nbsp;ošetření Vašeho kočičího přítele. Přestože je&nbsp;jeho&nbsp;použití velmi intuitivní, je&nbsp;žádoucí, aby&nbsp;Vás s&nbsp;ním seznámil odborník.</p>

			<p>V&nbsp;případě, že&nbsp;chcete tento produkt zakoupit, ukažte svému veterinárnímu&nbsp;lékaři <Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_gastro_limec_letak-2024.pdf'} target='_blank'>přiložený&nbsp;leták</Link> nebo jej odkažte na&nbsp;náš web, kde&nbsp;je&nbsp;k&nbsp;dispozici&nbsp;objednávkový formulář pro&nbsp;zaslání tohoto produktu. GASTRO límec obratem&nbsp;odešleme přímo do&nbsp;jeho ordinace, kde&nbsp;se&nbsp;s&nbsp;ním společně naučíte bezpečně&nbsp;zacházet.</p>

			<p>Přejeme mnoho chvil plných pohody s&nbsp;Vaším kočičím přítelem.</p>

			<p>Tým&nbsp;VETlímce</p>

			<p>#zaslouzisivic</p>

			<p className='link-text'>{'Stáhněte si tento leták o GASTRO límci pro jícnovou sondu, určený veterinárním lékařům '}
				<Link to={'https://vetlimce.blob.core.windows.net/vcz/VETlimce_gastro_limec_letak-2024.pdf'} className='disable-selection' target='_blank'>
					ZDE
				</Link>.
			</p>
		
		</div>
	);
};

export default AdvantagesBox;